export const environment = {
  production: true,
  pureSpectrum: {
    url: 'https://spectrumsurveys.com',
    activityUrl: 'https://activity.spectrumsurveys.com',
    decipherUrl: 'https://decipher.spectrumsurveys.com',
    ipsosUrl: 'https://ipsos.spectrumsurveys.com',
    nightcrawlerUrl: 'https://redirects.mysoapbox.com/api/v1',
    reconcilationUrl: 'https://adjustments.spectrumsurveys.com',
    feasibilityUrl: 'https://gateway.spectrumsurveys.com',
    priceRecommendUrl: 'https://black-box-production.spectrumsurveys.com',
    buyerExternalIntegrationUrl: 'https://partnersapi.spectrumsurveys.com',
    rmfUrl: 'https://adjustments.spectrumsurveys.com',
    // Used for decipher buyer settings iframe
    legacyPlatformUrl: 'https://platform.purespectrum.com',
    surveyStatiscticsServiceUrl: 'https://statistics.spectrumsurveys.com',
    reportServiceUrl: 'https://reportsservice.spectrumsurveys.com',
    qaToolsUrl: 'https://qa_tools.spectrumsurveys.com',
    storageSalt:
      'cdb810ff1f30a4847a0313950a61f0aca5d52d94519a647c2536c28e0556498b',
  },
  BUCKET_URL: 'https://ps-prod-zip-reports.s3.amazonaws.com',
  churnzeroUrl: 'https://analytics.churnzero.net',
  CATPTCHA_SITE_KEY: '6LdrE8QUAAAAAFo5nDaqxOflsQueY74M4fxIcf1u',
  QUICKBOOK_VAT_REALMS: [
    123146071401819, // PureSpectrum UK Limited
    9130354592299846, // PureSpectrum Pte. Ltd.
    9130351060401656, // PureSpectrum Pty Ltd.
  ],
  BUYER_TEST_LINK_SUPPLIER_ID: 23,
  PS_CMP_ID: 19,
  ENABLE_HOTJAR_EVENT: true, // Flag to indicate if Hotjar event caprturing is enabled or not
  FUSION_CMP_ID: 607,
  FUSION_API_URL: 'https://routerapi.spectrumsurveys.com',
  ZAPPI_STORE_BUYER_IDS: [4301, 4121],
  PUREPRICE_RATECARD_NOTIFICATION_SLACK_CHANNEL: 'jarvis-alerts',
  appcuesUrl: '//fast.appcues.com/221792.js',
  signUpUrl: 'https://www.purespectrum.com/schedule-a-demo',
  authUrl: 'https://auth.purespectrum.com',
  ENV: 'production',
};
